<template>
  <el-dialog class="left" :visible="visible" width="80rem" @close="close" top="3vh">
    <el-row slot="title">
      <el-col style="display: flex; justify-content: center; align-items: center">
        2001.人员待遇享受检查
        &nbsp;&nbsp;&nbsp;
        <medicare-card @emit="getMedicareInfo" />
      </el-col>
    </el-row>
    <el-form ref="searchForm" label-width="9rem" size="small" :rules="rules" label-position="right" :model="condition">
      <el-row :gutter="12">
        <el-col :span="8">
          <el-form-item prop="psn_no" label="人员编号">
            <el-input v-model="condition.psn_no" placeholder="人员编号" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="insutype" label="险种类型">
            <dict-selector size="small" v-model="condition.insutype" isMed dict-type="insutype" placeholder="险种类型" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="left-pad" label="定点医药机构编号" prop="fixmedins_code">
            <el-input v-model="condition.fixmedins_code" placeholder="定点医药机构编号" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="医疗类别" prop="med_type">
            <dict-selector size="small" v-model="condition.med_type" isMed dict-type="med_type" placeholder="医疗类别" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="left-pad" label="开始时间" prop="begntime">
            <el-date-picker v-model="condition.begntime" type="datetime" unlink-panels size="small" placeholder="开始时间" value-format="yyyy-MM-dd hh:mm:ss" style="width:100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="left-pad" label="结束时间">
            <el-date-picker v-model="condition.endtime" type="datetime" unlink-panels size="small" placeholder="结束时间" value-format="yyyy-MM-dd hh:mm:ss" style="width:100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="dise_codg" label="病种编码">
            <el-input v-model="condition.dise_codg" placeholder="病种编码" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="left-pad" label="病种名称" prop="dise_name">
            <el-input v-model="condition.dise_name" placeholder="病种名称" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="left-pad" label="手术操作代码">
            <el-input v-model="condition.oprn_oprt_code" placeholder="手术操作代码" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item class="left-pad" label="手术操作名称">
            <el-input v-model="condition.oprn_oprt_name" placeholder="手术操作名称" size="small" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="生育类别">
            <dict-selector size="small" v-model="condition.matn_type" isMed dict-type="matn_type" placeholder="生育类别" />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="计划生育手术类别">
            <dict-selector size="small" v-model="condition.birctrl_type" isMed dict-type="birctrl_type" placeholder="计划生育手术类别" />
          </el-form-item>
        </el-col>
        <el-col :span="24" class="right">
          <el-button type="primary" size="small" class="left-pad" :loading="loading" @click="search">
            查询
          </el-button>
        </el-col>
      </el-row>
    </el-form>
    <el-table class="top-pad" ref="table" border row-key="id" :data="result.trtinfo" height="30rem" v-loading="loading" highlight-current-row @row-dblclick="rowDblclick">
      <el-table-column label="序号" type="index" width="50" align="center"></el-table-column>
      <!--<el-table-column label="操作" align="center" width="100">
        <template slot-scope="scope">
          <el-button type="primary" icon="el-icon-finished" title="选择" plain size="mini" @click="select(scope.row)">
            选择
          </el-button>
        </template>
      </el-table-column>-->
      <el-table-column label="人员编号" prop="psn_no" align="center" width="180"></el-table-column>
      <el-table-column label="待遇检查类型" prop="trt_chk_type" align="center" width="110">
        <template slot-scope="{row}">
          {{row.trt_chk_type | dictText('trt_chk_type')}}
        </template>
      </el-table-column>
      <el-table-column label="基金支付类型" prop="fund_pay_type" align="center" width="110">
        <template slot-scope="{row}">
          {{row.trt_chk_type | dictText('trt_chk_type')}}
        </template>
      </el-table-column>
      <el-table-column label="基金款项待遇享受标志" prop="trt_enjymnt_flag" align="center" width="110">
        <template slot-scope="{row}">
          {{row.trt_enjymnt_flag | dictText('trt_enjymnt_flag')}}
        </template>
      </el-table-column>
      <el-table-column label="待遇检查结果" prop="trt_chk_rslt" align="center"></el-table-column>
      <el-table-column label="开始时间" prop="begndate" align="center" width="120"></el-table-column>
      <el-table-column label="结束时间" prop="enddate" align="center" width="120"></el-table-column>
    </el-table>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="save">确 定</el-button>
    </div> -->
  </el-dialog>
</template>

<script>
import api from "@/common/api";

const medicareCard = () => import(/* webpackChunkName: 'medicareCard' */ '@/components/_medcom/medicareCard');

export default {
  name: "trtinfo",
  props: {
    visible: Boolean,
    propData: {
      type: Object,
      default: null
    }
  },
  components: { medicareCard },
  data () {
    const { inputRuleFn, selectRuleFn } = this.$utils;
    return {
      loading: false,
      rules: {
        psn_no: inputRuleFn(),
        insutype: selectRuleFn(),
        fixmedins_code: inputRuleFn(),
        med_type: selectRuleFn(),
        begntime: selectRuleFn()
      },
      condition: {
        psn_no: '', // 44010000003501837949
        insutype: '', // 险种类型
        med_type: '', // 医疗类别
        fixmedins_code: this.$store.state.hospitalInfo.fixmedinsCode, // 定点医药机构编号
        begntime: '',
        endtime: '',
        matn_type: '',
        dise_codg: '', // 病种
        dise_name: '', // 病种名称
        oprn_oprt_code: '', // 手术操作
        oprn_oprt_name: '', // 手术操作名称
        birctrl_type: '', // 计划生育手术类别
      },
      entity: {},
      result: {
        trtinfo: []
      },
      header: null // 医保请求体里的header
    }
  },
  mounted() {
    const { cardInfo } = this.$store.state;
    if (this.propData) {
      this.condition.psn_no = this.propData.insuranceNo;
    } else if (cardInfo.psn_no) {
      // 刷卡了
      this.condition.psn_no = cardInfo.psn_no;
      this.condition.insutype = cardInfo.insutype;
    }
  },
  methods: {
    search () {
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          api.exec('2001', { data: this.condition }, this.header).then(({output: res}) => {
            if (res) {
              this.result = res;
            }
          }).catch(err => {
            this.$message({
              type: 'error',
              message: err.message || err,
              showClose: true,
              duration: 15000
            });
          }).finally(() => this.loading = false);
        }
      });
    },
    save () {
      if (!this.entity) {
        this.$message.warning('请选择人员信息！');
        return;
      }
      this.$emit("ok", this.entity);
      this.close();
    },
    close () {
      this.$emit("update:visible", false);
    },
    rowDblclick (row, column, event) {
      this.entity = row;
      this.save();
    },
    select (row) {
      this.entity = row;
      this.save();
    },
    // 获取刷卡后的数据
    getMedicareInfo(data) {
      this.condition.psn_no = data.baseinfo.psn_no;
      this.condition.insutype = data.insuinfo.insutype;
      this.header = data.header;
    }
  }
}
</script>

<style>
  .left .el-dialog__body {
    padding: 0 20px 10px 20px !important;
  }
</style>
